import {
  Component,
  OnInit,
  ViewChild,
  EventEmitter,
  Output,
} from "@angular/core";
import { SpeechRecognitionService } from "src/app/services/speechRecognition.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { IctprojectService } from "../projects/services/ictproject.service";
import { ictProjectModel } from "src/app/Models/ictProjectModel.model";
import { MatDialog } from "@angular/material/dialog";
import { InfoDialogComponent } from "src/app/components/info-dialog/info-dialog.component";
import { ConfirmationDialogComponent } from "src/app/components/confirmation-dialog/confirmation-dialog.component";
import { environment } from "src/environments/environment";
import { ViewfileComponent } from "src/app/components/viewfile/viewfile.component";
import { NgbTooltipConfig, NgbTooltip } from "@ng-bootstrap/ng-bootstrap";
import { AuthServiceService } from "src/app/services/auth-service.service";
import { GraphService } from "src/app/services/Organization/graph.service";
import { SearchPageService } from "../searchpage/searchpage.service";
import { ToastrService } from "ngx-toastr";
import { UserRoles } from "src/app/enums/userRoles.enum";
import { auto } from "@popperjs/core";
@Component({
  selector: "app-ictsearchpage",
  templateUrl: "./ictsearchpage.component.html",
  styleUrls: ["./ictsearchpage.component.css"],
})
export class IctsearchpageComponent implements OnInit {
  public showMic = true;
  public searchText = "";
  public operator = false;
  public type: string;
  public loading = false;
  public allProjects: any;
  public mainUrl = environment.mainUrl;
  public role: string;
  @ViewChild("tooltip") public tooltip: NgbTooltip;
  @Output() demo = new EventEmitter();
  restrictDownloadAndMail: boolean;
  kmsViewer: boolean = false;

  constructor(
    private speechRecognitionService: SpeechRecognitionService,
    private route: ActivatedRoute,
    private router: Router,
    // tslint:disable-next-line: align
    private ictProjectService: IctprojectService,
    private searchService: SearchPageService,
    private searchPageService: SearchPageService,
    private dialog: MatDialog,
    config: NgbTooltipConfig,
    private auth: AuthServiceService,
    // tslint:disable-next-line: align
    private graphService: GraphService,
    private toastr: ToastrService

  ) {
    this.role = this.auth.getRole();
    this.restrictDownloadAndMail = this.auth.getDownloadAndMailRestriction();
  }

  ngOnInit() {
    if (this.role.includes(UserRoles.Viewer)) {
      this.kmsViewer = true;
    }
    let urlSegments = this.router.url.split('/');
    this.type = decodeURIComponent(urlSegments[urlSegments.length - 1]);
    this.loading=true;
    setTimeout(() => {
      this.getAllProjects();
     }, 1000);
    // this.route.data.subscribe((params: Params) => {
    //   if (params) {
    //     if (params.type) {
    //       this.loading = true;
    //       this.type = params.type;
    //       this.searchText = this.searchService.ictSearchTerm;
    //       if (this.searchText !== "" && this.searchText !== undefined) {
    //         this.searchFiles();
    //       } else {
    //         this.getAllProjects();
    //       }
    //     } else {
    //       this.router.navigate(["Home/KMSPortal"]);
    //     }
    //   }
    // });
  }

  editICTProject(projectId: string) {
    this.loading = true;
    if (this.type == "Industry Deck") {
      this.router
        .navigate(["/Home/KMSPortal/Industry Deck/edit/" + projectId])
        .then(() => (this.loading = false));
    }
    else {
      this.router
        .navigate(["/Home/KMSPortal/Corporate Deck/edit/" + projectId])
        .then(() => (this.loading = false));
    }
  }
  onChangeProjectType(val: any) {
    if (val == "Case Studies") {
      this.router.navigate(["/Home/KMSPortal/Case Studies/Add"]);
    } else {
      if (this.type == "Industry Deck") {
        this.router.navigate(['Home/KMSPortal/Industry Deck/Add']);
      }
      else {
        this.router.navigate(['Home/KMSPortal/Corporate Deck/Add']);
      }
      //this.router.navigate(["project/ICT/addICTProject"]);
    }
  }

  getAllProjects() {
   
    this.loading = true;
    this.ictProjectService
      .getICTProjectsByContentType(this.type, 0, 100)
      .subscribe(
        (res) => {          
          this.allProjects = res;
       
          if (this.allProjects && this.allProjects.length <= 0) {
            this.loading = false;
          } else {
            if (this.allProjects) {
              this.allProjects.ictProjects.map(
                (project) =>
                  (project.tags = project.tags ? project.tags.join(", ") : "")
              );
            }
          }

          this.loading = false;
        },
        (err) => {
          this.loading = false;
          const dialogRef = this.dialog.open(InfoDialogComponent, {
            width: "280px",
            data: { message: "No files found!", class: "text-danger" },
          });
          this.loading = false;
        }
      );
  }

  switchDeckView() {
    this.demo.emit(true);
    this.searchPageService.ictSearchTerm = "";
    this.router.navigate(["/Home/KMSPortal"]);
    window.scroll(0, 0);
  }
  goToHome() {
    this.router.navigate(["/Home"]);
  }

  handleKeyUp(event: KeyboardEvent) {
    if (event.key === 'Backspace' && this.searchText === '') {
      this.searchText = '';
      this.searchFiles();
    }
  }

  searchFiles() {
    if (this.searchText !== "" && this.searchText !== undefined) {
      this.searchService.ictSearchTerm = this.searchText;
      let apiSearchText = this.searchText.trim();

      if (this.searchText) {
        apiSearchText = apiSearchText.replace(/~/g, "");
        apiSearchText = apiSearchText.replace(/ AND /g, " ");
        this.searchText = apiSearchText;
      }

      if (this.operator) {
        apiSearchText = apiSearchText.replace(/ /g, " AND ");
      }
      this.searchICTProject(apiSearchText);
    } else {
      this.getAllProjects();
    }
  }

  searchICTProject(searchTerm: string) {
    this.loading = true;
    this.ictProjectService.searchICTProject(this.type, searchTerm).subscribe(
      (res) => {
        this.allProjects = res;
        this.loading = false;
        if (res && res.ictProjects.length <= 0) {
          this.allProjects = null;
        } else {
          if (this.allProjects) {
            this.allProjects.ictProjects.map(
              (project) =>
                (project.tags = project.tags ? project.tags.join(", ") : "")
            );
          }
        }
      },
      (err) => {
        this.loading = false;
        this.allProjects = null;
        const dialogRef1 = this.dialog.open(InfoDialogComponent, {
          width: "280px",
          data: { message: "No files found!", class: "text-danger" },
        });
      }
    );
  }

  deleteICTProject(projectId: string) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: auto,
      minWidth: '500px',
      height: auto,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.data === "DELETE") {
        this.loading = true;
        this.ictProjectService.deleteICTProjectById(projectId).subscribe(
          (res) => {
            this.toastr.success("Project deleted  Successfully");       
            this.loading = false;
            setTimeout(() => {
              this.getAllProjects();
             }, 1000);
          },
          (err) => {
            this.loading = false;
            const dialogRef1 = this.dialog.open(InfoDialogComponent, {
              width: "280px",
              data: {
                message: "Unable to delete project",
                class: "text-danger",
              },
            });
          }
        );
      }
    });
  }
  clearSearch() {
    this.searchText = ''; // Clear the search text
    this.searchFiles();
  }
  downloadICTProject(attachment) {
    this.loading = true;
    const documentId = attachment.fileURL;
    if (documentId) {
      this.graphService.getDownloadUrl(documentId).subscribe(
        (response) => {
          if (response) {
            const link = document.createElement("a");
            link.setAttribute("type", "hidden");
            link.href = response.url;
            link.download = attachment.attachmentName;
            document.body.appendChild(link);
            link.click();
            link.remove();
            this.updateICTDownloadCount(attachment);
            this.loading = false;
          } else {
            this.loading = false;
            this.toastr.error("No files to download");
          }
        },
        (err) => {
          this.loading = false;
          this.toastr.error("No files to download")

        }
      );
    }
    else {
      this.loading = false;
      this.toastr.error("No files to download")
    }
  }

  viewICTProject(url, id) {
    const dialogRef = this.dialog.open(ViewfileComponent, {
      width: "900px",
      height: "500px",
      panelClass: "view-file",
      data: { Method: "CaseStudies", iFrameURL: url },
    });
    ;
    if (url != null) {

      dialogRef.afterClosed().subscribe((result) => {

        this.ictProjectService.updateICTViewCount(id).subscribe(
          (res) => {
            if (res) {
              id.viewCount = id.viewCount + 1;
            } else {
              this.toastr.error("Could not update the View Count. Please try again after some time");
            }
          },
          (err) => {
            this.loading = false;
          }
        );
      });
    }
    else {
      this.toastr.error("No files to view");
    }
  }

  updateICTDownloadCount(attachment) {
    this.ictProjectService.updateICTDownloadCount(attachment.id).subscribe(
      (res) => {
        if (res) {
          attachment.downloadCount = attachment.downloadCount + 1;
        } else {
          this.toastr.error("Could not update the Download Count. Please try again after some time");
        }
      }
    );
  }

  stopSpeech() {
    this.speechRecognitionService.destroySpeechObject();
    this.showMic = true;
  }

  checkAllTokens() {
    this.operator = !this.operator;
  }

  activateSpeech(): void {
    this.showMic = false;
    if (this.searchText) {
      this.searchText = "";
    }
    this.speechRecognitionService.record().subscribe(
      (value) => {
        this.searchText = this.searchText + value;
        this.searchFiles();
        this.stopSpeech();
      },
      (err) => {
        if (err.error === "no-speech") {
          this.activateSpeech();
        }
      },
      () => {
      }
    );
  }

  dismissSidebar() {
    $("#sidebar").removeClass("active");
    $("#sidebar_r").removeClass("active");
    $(".overlay").removeClass("active");
  }
}
